import { ReactNode } from 'react';

export type IconName =
  | 'dashboard' | 'campaign' | 'brand' | 'social' | 'task'
  | 'search' | 'plus' | 'filter'
  | 'chevron' | 'chevronDown' | 'chevronLeft' | 'chevronRight'
  | 'alert' | 'calendar' | 'clock' | 'x' | 'check'
  | 'user' | 'settings' | 'inbox' | 'sparkle' | 'trending'
  | 'link' | 'more' | 'instagram' | 'facebook' | 'flame' | 'archive'
  | 'bolt' | 'globe' | 'tag' | 'home' | 'mail' | 'image'
  | 'video' | 'users' | 'helpCircle' | 'logOut' | 'copy'
  | 'bannerFull' | 'bannerHalf' | 'promoStrip' | 'carousel' | 'logoRow' | 'popup' | 'navBar' | 'eye' | 'cards' | 'menu';

const paths: Record<IconName, ReactNode> = {
  dashboard: (<><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>),
  campaign: (<><path d="M3 11l18-7v16L3 13z"/><path d="M11.6 14.6A2 2 0 0 1 8 13V8"/></>),
  brand: (<><path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6z"/></>),
  social: (<><rect x="3" y="4" width="18" height="17" rx="2"/><path d="M3 9h18M8 2v4M16 2v4"/></>),
  task: (<><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M8 12l3 3 5-6"/></>),
  search: (<><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></>),
  plus: (<><path d="M12 5v14M5 12h14"/></>),
  filter: (<><path d="M3 5h18M6 12h12M10 19h4"/></>),
  chevron: (<><path d="M9 6l6 6-6 6"/></>),
  chevronDown: (<><path d="M6 9l6 6 6-6"/></>),
  chevronLeft: (<><path d="M15 6l-6 6 6 6"/></>),
  chevronRight: (<><path d="M9 6l6 6-6 6"/></>),
  alert: (<><path d="M12 2L1 21h22L12 2z"/><path d="M12 9v5M12 17h0"/></>),
  calendar: (<><rect x="3" y="4" width="18" height="17" rx="2"/><path d="M3 9h18M8 2v4M16 2v4"/></>),
  clock: (<><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>),
  x: (<><path d="M6 6l12 12M6 18L18 6"/></>),
  menu: (<><path d="M4 6h16M4 12h16M4 18h16"/></>),
  check: (<><path d="M5 12l5 5L20 7"/></>),
  user: (<><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></>),
  settings: (<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 0 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 0 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 0 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3 1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 0 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8 1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/></>),
  inbox: (<><path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.5 5.5L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.5-6.5A2 2 0 0 0 16.7 4H7.3a2 2 0 0 0-1.8 1.5z"/></>),
  sparkle: (<><path d="M12 3l2 7 7 2-7 2-2 7-2-7-7-2 7-2z"/></>),
  trending: (<><path d="M22 7l-9 9-5-5L2 17"/><path d="M16 7h6v6"/></>),
  link: (<><path d="M10 14a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 10a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></>),
  more: (<><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></>),
  instagram: (<><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/></>),
  facebook: (<><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></>),
  flame: (<><path d="M12 2s4 4 4 9a4 4 0 1 1-8 0c0-2 1-3 1-3s-1 6 3 6-1-7 0-12z"/></>),
  archive: (<><rect x="3" y="4" width="18" height="5" rx="1"/><path d="M5 9v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9M10 13h4"/></>),
  bolt: (<><path d="M13 2L3 14h7l-1 8 10-12h-7z"/></>),
  eye: (<><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></>),
  globe: (<><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18z"/></>),
  tag: (<><path d="M20.6 13.4L13.4 20.6a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><circle cx="7" cy="7" r="1" fill="currentColor"/></>),
  home: (<><path d="M3 10l9-7 9 7v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></>),
  mail: (<><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 7l10 7 10-7"/></>),
  image: (<><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="M21 15l-5-5L5 21"/></>),
  video: (<><rect x="3" y="6" width="13" height="12" rx="2"/><path d="M16 10l5-3v10l-5-3z"/></>),
  users: (<><circle cx="9" cy="8" r="4"/><path d="M2 21a7 7 0 0 1 14 0M17 11a4 4 0 0 0 0-8M22 21a7 7 0 0 0-4-6"/></>),
  helpCircle: (<><circle cx="12" cy="12" r="9"/><path d="M9.1 9a3 3 0 1 1 5.8 1c0 2-3 3-3 3M12 17h0"/></>),
  logOut: (<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/></>),
  // Homepage placement types — one distinct glyph per slot on the page.
  bannerFull: (<><rect x="2" y="6" width="20" height="12" rx="1.5"/><path d="M6 12h12"/></>),
  bannerHalf: (<><rect x="2" y="6" width="9" height="12" rx="1.5" fill="currentColor" stroke="none"/><rect x="13" y="6" width="9" height="12" rx="1.5"/></>),
  cards: (<><rect x="1.5" y="6" width="4.5" height="12" rx="1"/><rect x="7" y="6" width="4.5" height="12" rx="1"/><rect x="12.5" y="6" width="4.5" height="12" rx="1"/><rect x="18" y="6" width="4.5" height="12" rx="1"/></>),
  promoStrip: (<><rect x="2" y="9" width="20" height="6" rx="1.5"/><circle cx="7" cy="12" r="1" fill="currentColor" stroke="none"/><path d="M11 12h7"/></>),
  carousel: (<><rect x="7" y="5" width="10" height="14" rx="1.5"/><path d="M2 8v8M22 8v8"/><path d="M4 8v8M20 8v8"/></>),
  logoRow: (<><circle cx="5" cy="12" r="2.5"/><circle cx="12" cy="12" r="2.5"/><circle cx="19" cy="12" r="2.5"/></>),
  popup: (<><rect x="3" y="3" width="18" height="18" rx="2" strokeDasharray="2.5 2.5"/><rect x="7" y="8" width="10" height="8" rx="1.5" fill="currentColor" stroke="none"/></>),
  navBar: (<><rect x="2" y="3" width="20" height="5" rx="1.5" fill="currentColor" stroke="none"/><path d="M4 13h16M4 17h10"/></>),
  copy: (<><rect x="9" y="9" width="11" height="11" rx="1.5"/><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/></>),
};

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

export const Icon = ({ name, size = 14, className = 'icon' }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {paths[name] ?? null}
  </svg>
);

export default Icon;
